import DefaultUserIcon from './DefaultUserIcon';

export default DefaultUserIcon;
